import {
  getSrc,
} from 'gatsby-plugin-image';

import DecorativeVideo from '@klv/atoms/decorative-video';
import Image from '@klv/atoms/image';
import { Rive } from '@klv/atoms/rive';

import type { IMixedMediaComponent } from './types';


const MixedMedia = ({ mixedMedia, ...props }: IMixedMediaComponent) => {
  const image = mixedMedia?.image?.gatsbyImage || mixedMedia?.image?.localFile?.childImageSharp?.gatsbyImageData;
  const videoPoster = mixedMedia?.video?.poster?.gatsbyImage || mixedMedia?.video?.poster?.localFile?.childImageSharp?.gatsbyImageData;

  if (mixedMedia.mediaType === 'video' && mixedMedia?.video && videoPoster) {
    const {
      loop,
      poster,
      videoUrl,
    } = mixedMedia.video;
    const caption = '';
    const posterUrl = (poster?.gatsbyImage && getSrc(poster.gatsbyImage)) || poster?.localFile?.publicUrl || '';
    const title = '';

    return (
      <DecorativeVideo
        data-chromatic="ignore"
        caption={caption}
        loop={loop}
        poster={posterUrl}
        posterImageData={videoPoster}
        title={title}
        url={videoUrl}
        {...props}
      />
    );
  }

  if (mixedMedia.mediaType === 'rive' && mixedMedia.rive?.riveFile) {
    return (
      <Rive
        {...mixedMedia.rive}
        {...props}
      />
    );
  }

  if (mixedMedia.mediaType === 'rive_animation' && mixedMedia.riveAnimation?.riveAnimation) {
    // Extract rive configuration from WordPress data
    const riveFile = mixedMedia.riveAnimation.riveAnimation.riveFile;
    const layout = mixedMedia.riveAnimation.riveAnimation.riveData?.layout;
    const textRuns = mixedMedia.riveAnimation.riveAnimation.riveData?.textRuns || [];
    const ariaLabel = mixedMedia.riveAnimation.riveAnimation.riveData?.ariaLabel;
    
    // Early return if no rive data
    if (!riveFile?.mediaItemUrl) {
      return null;
    }
    
    return (
      <Rive
        riveFile={riveFile}
        aspectRatio={layout?.aspectRatio}
        flexibleLayout={layout?.isFlexible}
        height={layout?.height}
        riveText={textRuns}
        ariaLabelText={ariaLabel}
        {...props}
      />
    );
  }

  if (mixedMedia?.image && (image || mixedMedia.image.sourceUrl)) {
    // When we have Gatsby image data, use it; otherwise create a proper IMediaItem structure
    const imageData = image || {
      altText: mixedMedia.image.altText,
      sourceUrl: mixedMedia.image.sourceUrl,
      srcSet: mixedMedia.image.srcSet,
      mediaDetails: mixedMedia.image.mediaDetails,
    };

    return (
      <Image
        altText={mixedMedia.image.altText}
        imageData={imageData}
        sourceUrl={mixedMedia.image.sourceUrl}
        srcSet={mixedMedia.image.srcSet}
        mediaDetails={mixedMedia.image.mediaDetails}
        {...props}
      />
    );
  }

  return null;
};

export default MixedMedia;
